import React from "react";
import { Toast, ToastHeader, ToastBody } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function NotificationToast({
  icon,
  iconStyle = { color: "orange", marginRight: "160px" },
  title,
  message,
  fade,
  containerStyle = {}
}) {

  message = message.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ));

  return (
    <div
      style={{
        position: "fixed",
        top: "20px",
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        zIndex: 9999,
        ...containerStyle
      }}
    >
      <Toast fade={fade}>
        <ToastHeader>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div style={{ marginRight: "1.4rem" }}>
              <FontAwesomeIcon
                icon="exclamation-triangle"
                style={{ color: "orange" }}
              />
            </div>
            <span>{title}</span>
          </div>
        </ToastHeader>
        <ToastBody>{message}</ToastBody>
      </Toast>
    </div>
  );
};

export default NotificationToast;